import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/Spinner';
import InternalUserService from '../../../services/internal-user.service';
import { AuthContext } from '../../../contexts/AuthContext';
import { Modules, AuthRoutes } from '../../../enums';

const Activate: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setLoggedInUser, setToken, setPermissions, setIsSystemAdmin } = useContext(AuthContext);

  const [status, setStatus] = useState<'pending' | 'error'>('pending');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setErrorMessage(t('activate.pageTexts.missingToken'));
      return;
    }

    InternalUserService.activate(token)
      .then((response: any) => {
        const data = response?.data ?? {};
        const user = data.user ?? {};

        setLoggedInUser(user);
        setToken(data.token ?? '');
        setPermissions(user.permissions ?? []);
        setIsSystemAdmin(false);

        navigate(`${Modules.my}${AuthRoutes.account}?tab=security`, { replace: true });
      })
      .catch((err: any) => {
        setStatus('error');
        setErrorMessage(err?.response?.data?.message ?? t('activate.pageTexts.invalidToken'));
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === 'error') {
    return (
      <div className="w-px-400 mx-auto pt-5 pt-lg-0 text-center">
        <h5 className="mb-3">{t('activate.pageTexts.title')}</h5>
        <p className="text-danger">{errorMessage}</p>
        <p className="text-muted small">{t('activate.pageTexts.contactAdmin')}</p>
      </div>
    );
  }

  return (
    <div className="w-px-400 mx-auto pt-5 pt-lg-0 text-center">
      <h5 className="mb-4">{t('activate.pageTexts.title')}</h5>
      <Spinner />
      <p className="text-muted small mt-3">{t('activate.pageTexts.activating')}</p>
    </div>
  );
};

export default Activate;
